import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function Text(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="TextIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#AEC3EB" />
        <path
          d="M6.08325 7.33301V9.83301H10.2499V19.833H12.7499V9.83301H16.9166V7.33301H6.08325ZM21.9166 11.4997H14.4166V13.9997H16.9166V19.833H19.4166V13.9997H21.9166V11.4997Z"
          fill="#546A99"
        />
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default Text;
